import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Add, Remove } from "@mui/icons-material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useTranslation } from "react-i18next";

import { AddHeader } from "../../components/AddHeader";
import { ExerciseTypeMark } from "../../components/ExerciseTypeMark";
import { ExerciseAddLayout } from "./ExerciseAddLayout";
import exer from "../../components/assets/Competency bloc.png";
import {
  getexercise,
  updateexercise,
} from "../../components/funtionsBD/Mainservice";
import Loader from "../../components/Loading/Loader";
import { currentAppLanguage } from "../../utils/appLanguages";
import { localizedExerciseName, localizedField } from "../../utils/localizedCatalogFields";
import { competencyBlockIconSrc } from "../../utils/competencyBlockIcon";

export const WCB3 = () => {
  const [list, setlist] = useState([]);
  const [loading, setloading] = useState(true);
  const [error, seterror] = useState();
  const [open, setopen] = useState(false);
  const [success, setsuccess] = useState();
  const [ex, setex] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state || {};
  const { t, i18n } = useTranslation();
  const currentlng = currentAppLanguage(i18n);

  useEffect(() => {
    fetchExercises();
  }, [data.sessionid, data.grpid, data.cbid]);

  const normalizeDurationForAttach = (value) => {
    const parsed = parseInt(String(value ?? "").trim(), 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 10;
  };

  const fetchExercises = async () => {
    setloading(true);
    seterror("");
    setlist([]);
    setex(undefined);

    if (!data.cbid) {
      seterror(t("missingCompetencyBlock"));
      setloading(false);
      return;
    }

    try {
      const response = await getexercise({
        cb_id: data.cbid,
        group_id: data.grpid,
      });
      const data1 = (response.data.data || []).map((d) => ({
        ...d,
        duration: normalizeDurationForAttach(data.duration ?? d.duration ?? 10),
      }));
      setlist(data1);
      if (data1.length === 0) {
        seterror(t("te_not_found") || "No exercises found for this competency block.");
      }
    } catch (err) {
      console.error(err);
      seterror(err?.message || "Failed to load exercises");
    } finally {
      setloading(false);
    }
  };

  const handleex = (i) => {
    seterror("");
    setex(i.ex_id);
  };

  const handleadd = async () => {
    if (!ex) {
      seterror(t("please_select_ex") || "Please select an exercise");
      return;
    }
    try {
      const params = {
        te_id: data.teid,
        replace_ex_id: ex,
        existing_ex_id: "",
        cb_id: data.cbid,
      };
      const response = await updateexercise(params);

      setsuccess(response.data.message);
      setopen(true);
      setex(undefined);
      setTimeout(() => {
        navigate("/planning");
      }, 1000);
    } catch (err) {
      seterror(err?.message || "Error replacing exercise");
    }
  };

  return (
    <ExerciseAddLayout>
      <AddHeader title={t("addex")} />
      <div className="navwithadd">
        <p className="exercise_type_define">
          {data.cb} {"->"}
        </p>
        <p className="add_button" onClick={handleadd} style={{ opacity: ex ? 1 : 0.6, pointerEvents: ex ? "auto" : "none" }}>
          {t("add")}
        </p>
      </div>
      <p className="error_msg">{error}</p>

      {loading ? (
        <Loader />
      ) : (
        <div className="exercise_session_div">
          {list?.map((i, index) => {
            const mark =
              competencyBlockIconSrc(i.cb_details) ||
              competencyBlockIconSrc(data.cb);
            return (
            <div
              key={i.ex_id || index}
              className={
                ex === i.ex_id ? "ex_add_box selected_box" : "ex_add_box"
              }
              style={{ cursor: "pointer" }}
              onClick={() => handleex(i)}
            >
              <div className="ex_up_box">
                <div
                  className={`ex-image-add${
                    mark ? " ex-image-add--mark" : ""
                  }`}
                >
                  {mark ? (
                    <ExerciseTypeMark src={mark} />
                  ) : (
                    <img src={exer} alt="" />
                  )}
                  {ex === i.ex_id ? (
                    <Remove className="ex_add_icon" />
                  ) : (
                    <Add className="ex_add_icon" />
                  )}
                </div>
                <div className="exercise-addinfo">
                  <h4>{localizedExerciseName(i, currentlng)}</h4>
                  <div className="exercise_types">
                    <div className="exercise_duration">
                      <p>{i.duration}</p>
                      <p>{t("min")}</p>
                    </div>
                    <p className="exercise_cb">
                      {i.cb_details
                        ? localizedField(i.cb_details, "cb_name", currentlng)
                        : localizedField(i.sub_type_ex, "sub_type_name", currentlng) || data.cb || ""}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            );
          })}
        </div>
      )}

      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={() => setopen(false)}
      >
        <Alert variant="filled" severity="success">
          {success}
        </Alert>
      </Snackbar>
    </ExerciseAddLayout>
  );
};
